<script setup>

import ProductsSlider from "@/Components/Misc/ProductsSlider.vue";

import {ref, onMounted} from 'vue';

const products = ref(null);
const ready = ref(false);

const props = defineProps({
	product_uuids: {
		type: String,
		default: []
	}
});

onMounted(() => {

	axios.post(route('products.getbyuuids'), {
		product_uuids: props.product_uuids.split(",")
	}).then((response) => {
		products.value = response.data.products;
		ready.value = true;
	});

});

</script>

<template>
	<ProductsSlider :items="products" v-if="ready"></ProductsSlider>
</template>

<script>
export default {
	name: "ProductSliderProvisioner"
}
</script>